module.exports = __webpack_public_path__ + "components/country-flag/static/gb-eng-b01bf0906f1e901bf5b2ee9bc4dd9e52.svg";